export function isRealtimeSuspended(): boolean {
  return process.env.NODE_ENV === 'development' && document.visibilityState === 'hidden'
}

export function onRealtimeVisibilityChange(callback: () => void): () => void {
  if (process.env.NODE_ENV !== 'development') {
    return () => undefined
  }

  document.addEventListener('visibilitychange', callback)
  return () => document.removeEventListener('visibilitychange', callback)
}
